module.exports = __webpack_public_path__ + "img/micro_camara.768e9424.gif";